var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.592 2.05a1.065 1.065 0 0 1 1.352.627l.043.145.022.15c.011.146-.01.294-.058.434h.002l-6.118 17.882a1.07 1.07 0 0 1-.985.723 1.07 1.07 0 0 1-.95-.525l-.072-.146-2.992-7.464-.054-.118a1.3 1.3 0 0 0-.541-.54l-.118-.054-7.462-2.992v-.001a1.072 1.072 0 0 1-.465-1.626l.106-.124a1.1 1.1 0 0 1 .41-.256l17.88-6.117zm-8.82 11.025q.038.061.072.125l.106.227v.001l2.862 7.14 5.476-16.009zM3.43 9.187l7.14 2.863.227.105q.064.034.127.071l8.519-8.518z"
  })));
};
export default SvgSend;